import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Add from '@material-ui/icons/Add'
import Paper from "@material-ui/core/Paper";
import Select from "react-select";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment-timezone";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Objects} from "../index";

export default class HelpDesksContactedHistory extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Help_Desks_Contacted._name, 'GET_HISTORY');
		model.filter = {'user': props.user};
		super(props, model);
		this.request = 'GET_HISTORY';
		this.state.limit = 40;
		this.state.filter = {};
	}

	async componentDidMount() {
		await this.getHelpdesksContacted();
	}

	getHelpdesksContacted = async () => {
		let model = new API.BuildClass(Types.Help_Desks_Contacted._name, 'GET_HISTORY');
		model.limit = 40;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		model.filter = {
			'user': this.props.user
		}
		this.setState({loading: true});
		let data = await model.submit(null, 'GET_HISTORY');
		this.setState({data: data.items, loading: false})
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		//this might be broken but i legit can't see how it ever worked when coming from HelpDesks so idk man
		const columns = [
			{
				Header: "Date (AZ Time)",
				id: "created",
				width: 175,
				accessor: obj => moment(obj.created).tz('America/Phoenix').format('MM/DD/YYYY h:mm A')
			},
			{
				Header: "Last Spoken With",
				id: "agent",
				width: 200,
				accessor: obj => obj.agent
			},
			{
				Header: "Spoken About",
				id: "notes",
				accessor: 'notes',
				style: { 'whiteSpace': 'unset' }
			}
		]
		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.getHelpdesksContacted} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
